import { QuestionMediaInfo } from './question-media-info';

export class RichText {
  template: string;
  mediaInfos: QuestionMediaInfo[];
  html: string;


  constructor() {
    this.template = '';
    this.mediaInfos = [];
    this.html = '';
  }
}
